import { Button } from "@/components/ui/button";

interface NewQuoteCardProps {
  title?: string;
  buttonLabel?: string;
  onClick?: () => void;
}

export default function NewQuoteCard({
  title = "Fazer nova cotação",
  buttonLabel = "Iniciar",
  onClick,
}: NewQuoteCardProps) {
  return (
    <div className="bg-white rounded-[20px] py-4 px-6 flex items-center justify-between">
      <span className="text-lg font-semibold text-n-green">{title}</span>

      <Button variant="border" type="button" size="sm" onClick={onClick}>
        {buttonLabel}
      </Button>
    </div>
  );
}
